<template>
  <my-profile-menu-layout>
    <payment-overview></payment-overview>
  </my-profile-menu-layout>
</template>

<script>
  import MyProfileMenuLayout from "@/components/layout/MyProfileMenuLayout";
  import PaymentOverview from '@/components/myprofile/PaymentOverview.vue';
  import CurrentUserMixin from "@/mixins/CurrentUserMixin";

  export default {
    name: "ProfilePaymentOverview",
    data() {
      return {
      }
    },
    mixin: [CurrentUserMixin],
    mounted() {
      this.$store.commit('user/set_current_project_id', this.project_id)
    },
    components: {
      MyProfileMenuLayout, PaymentOverview
    },
    computed: {
    },
    methods: {
    },
  }
</script>

<style scoped>

</style>